import React, { useEffect, useRef } from 'react'
import * as echarts from 'echarts';
import Grid from '@mui/material/Grid2';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import './reports.css'
function MyDashboard() {
    const navigate = useNavigate();
    const pieFullChartRef = useRef(null);
    const pieChartRef = useRef(null);
    const barChartRef = useRef(null);
    const lineChartRef = useRef(null);

    useEffect(() => {
        if (pieFullChartRef.current) {
        const pieFullChart = echarts.init(pieFullChartRef.current);

        pieFullChart.setOption({
            title: {
                text: 'Knowledge Details',
                left: 'center'
                // subtext: 'Fake Data',
            },
            tooltip: {
                trigger: 'item'
            },
            legend: {
                // orient: 'vertical',
                left: 'center'
            },
            series: [
                {
                name: 'Access From',
                type: 'pie',
                radius: '50%',
                data: [
                    { value: 40, name: '', itemStyle: { color: '#C32A7C' } },
                    { value: 38, name: '', itemStyle: { color: '#1A5298' } },
                    { value: 32, name: '', itemStyle: { color: '#95DAFF' } },
                    { value: 30, name: '', itemStyle: { color: '#CAECFF' } },
                    { value: 28, name: '', itemStyle: { color: '#124B6A' } },
                ],
                emphasis: {
                    itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                }
                }
            ]
        });
        
        return () => {
            pieFullChart.dispose();
        };
        }
    }, []);

    useEffect(() => {
        if (pieChartRef.current) {
        const pieChart = echarts.init(pieChartRef.current);

        const pieOption = {
            legend: {
                top: 'bottom'
            },
            title: {
                text: 'About Task',
                left: 'center'
            },
            tooltip: {
                trigger: 'item'
            },
            toolbox: {
            show: true,
            feature: {
                mark: { show: true },
                saveAsImage: { show: true }
            }
            },
            series: [
            {
                name: 'Tasks',
                type: 'pie',
                radius: [50, 100],
                center: ['50%', '50%'],
                roseType: 'area',
                itemStyle: {
                    borderRadius: 5
                },
                data: [
                    { value: 40, name: 'Total task', itemStyle: { color: '#C32A7C' } },
                    { value: 38, name: 'My task', itemStyle: { color: '#1A5298' } },
                    { value: 32, name: 'Completed task', itemStyle: { color: '#95DAFF' } },
                    { value: 30, name: 'Pending task', itemStyle: { color: '#124B6A' } },
                ]
            }
            ]
        };

        pieChart.setOption(pieOption);
        
        return () => {
            pieChart.dispose();
        };
        }
    }, []);

    useEffect(() => {
        if (barChartRef.current) {
        const barChart = echarts.init(barChartRef.current);

        const barChartOption = {
            title: {
                text: 'Rate of Joins per Month',
                left: 'center'
            },
            tooltip: {
                trigger: 'item'
            },
            xAxis: {
                type: 'category',
                data: ['Jan', 'Feb', 'Mar', 'Apr']
            },
            yAxis: {
                type: 'value'
            },
            series: [
                {
                data: [
                    { value: 40, name: 'Total task', itemStyle: { color: '#1A5298' } },
                    { value: 38, name: 'My task', itemStyle: { color: '#1A5298' } },
                    { value: 32, name: 'Completed task', itemStyle: { color: '#1A5298' } },
                    { value: 30, name: 'Pending task', itemStyle: { color: '#1A5298' } },
                ],
                type: 'bar'
                }
            ]
        };

        barChart.setOption(barChartOption);
        
        return () => {
            barChart.dispose();
        };
        }
    }, []);

    useEffect(() => {
        if (lineChartRef.current) {
        const lineChart = echarts.init(lineChartRef.current);

        const lineChartOption = {
            title: {
                text: 'Rate of Joins per week',
                left: 'center'
            },
            tooltip: {
                trigger: 'item'
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
            },
            yAxis: {
                type: 'value'
            },
            series: [
                {
                    data: [820, 932, 901, 934, 1290, 1330, 1320],
                    type: 'line',
                    areaStyle: {}
                }
            ]
        };

        lineChart.setOption(lineChartOption);
        
        return () => {
            lineChart.dispose();
        };
        }
    }, []);

    // useEffect(() => {
    //     if (lineChartRef.current) {
    //     const lineChart = echarts.init(lineChartRef.current);

    //     const lineChartOption = {
    //         title: {
    //             text: 'Barchart for Jobseekers',
    //             left: 'center'
    //         },
    //         tooltip: {
    //             trigger: 'item'
    //         },
    //         xAxis: {
    //             type: 'category',
    //             data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri']
    //         },
    //         yAxis: {
    //             type: 'value'
    //         },
    //         series: [
    //             {
    //             data: [
    //                 { value: 190, itemStyle: { color: '#C32A7C' } },
    //                 { value: 100, itemStyle: { color: '#1A5298' } },
    //                 { value: 50, itemStyle: { color: '#95DAFF' } },
    //                 { value: 170, itemStyle: { color: '#CAECFF' } },
    //                 { value: 120, itemStyle: { color: '#124B6A' } },
    //             ],
    //             type: 'bar'
    //             }
    //         ]
    //     };

    //     lineChart.setOption(lineChartOption);

    //     // Clean up
    //     return () => {
    //         lineChart.dispose();
    //     };
    //     }
    // }, []);
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{sm:12}} container className="main_jobseeker">
                <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                    <h3>My Dashboard</h3>
                    <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> My dashboard</span>
                </Grid>
                <Grid size={{xs:12}} container className="my-3">
                    <Grid size={{md:4, xs:12}} container className="px-2 mt-3">
                        <Grid size={{xs:12}} container className="report_pagecharts">
                            <div ref={pieChartRef} style={{ width: '100%', height: '400px' }} />
                        </Grid>
                    </Grid>
                    <Grid size={{md:4, xs:12}} container className="px-2 mt-3">
                        <Grid size={{xs:12}} container className="report_pagecharts">
                            <div ref={pieFullChartRef} style={{ width: '100%', height: '400px' }} />
                        </Grid>
                    </Grid>
                    {/* <Grid size={{md:4, xs:12}} container className="px-2 mt-3">
                        <Grid size={{xs:12}} container className="report_pagecharts">
                            <div ref={barChartRef} style={{ width: '100%', height: '400px' }} />
                        </Grid>
                    </Grid> */}
                </Grid>
            </Grid>
        </div>
    </div>
  )
}

export default MyDashboard
